import {DateTime} from 'luxon';

import {getCultureCode, getDateMask} from '@/use/culture';
import {parseRFQDateTime} from '@/use/formatRFQDateTime';

export default function formatRFQDate(date: string | null | undefined): string {
  if (!date) {
    return '';
  }

  const formattedDate = DateTime.fromISO(date, {locale: getCultureCode()});
  const parsedDate = formattedDate.isValid ? formattedDate : parseRFQDateTime(date);

  return parsedDate ? parsedDate.toFormat(getDateMask('long')) : date;
}
